export default __webpack_public_path__ + "static/media/laptop-using-lg-3.38a330f5.jpg";